/**
 * Inline SVGs rather than an icon package: six icons do not justify a
 * dependency, and these ship with the component tree with no extra fetch.
 * All are decorative — the control each sits beside carries the accessible name.
 */
const base = {
  width: 20,
  height: 20,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
};

export const MailIcon = () => (
  <svg {...base} aria-hidden="true" focusable="false">
    <rect x="2.5" y="4.5" width="19" height="15" rx="2.5" />
    <path d="m3 7 8.2 5.6a1.5 1.5 0 0 0 1.6 0L21 7" />
  </svg>
);

export const LockIcon = () => (
  <svg {...base} aria-hidden="true" focusable="false">
    <rect x="4" y="10.5" width="16" height="10.5" rx="2.5" />
    <path d="M8 10.5V7a4 4 0 0 1 8 0v3.5" />
  </svg>
);

export const EyeIcon = () => (
  <svg {...base} aria-hidden="true" focusable="false">
    <path d="M2 12s3.6-6.5 10-6.5S22 12 22 12s-3.6 6.5-10 6.5S2 12 2 12Z" />
    <circle cx="12" cy="12" r="2.8" />
  </svg>
);

export const EyeOffIcon = () => (
  <svg {...base} aria-hidden="true" focusable="false">
    <path d="M10.6 6.1A9.9 9.9 0 0 1 12 5.5c6.4 0 10 6.5 10 6.5a18 18 0 0 1-3.2 4.1M6.3 7.9A18 18 0 0 0 2 12s3.6 6.5 10 6.5a9.6 9.6 0 0 0 3.6-.7" />
    <path d="M9.9 9.9a3 3 0 0 0 4.2 4.2" />
    <path d="m3 3 18 18" />
  </svg>
);

export const SignInIcon = () => (
  <svg {...base} aria-hidden="true" focusable="false" width={21} height={21}>
    <path d="M14 3h4.5A1.5 1.5 0 0 1 20 4.5v15a1.5 1.5 0 0 1-1.5 1.5H14" />
    <path d="M10 17l5-5-5-5" />
    <path d="M15 12H3" />
  </svg>
);

export const AlertIcon = () => (
  <svg {...base} aria-hidden="true" focusable="false" width={18} height={18} style={{ flexShrink: 0, marginTop: 1 }}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7.5v5M12 16h.01" />
  </svg>
);
